import { render, staticRenderFns } from "./HomeWishlistFR.vue?vue&type=template&id=4d762c48&scoped=true"
import script from "./HomeWishlistFR.vue?vue&type=script&lang=js"
export * from "./HomeWishlistFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d762c48",
  null
  
)

export default component.exports